import { render, staticRenderFns } from "./MemberRatingDetails.vue?vue&type=template&id=17feef81&scoped=true"
import script from "./MemberRatingDetails.vue?vue&type=script&lang=js"
export * from "./MemberRatingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17feef81",
  null
  
)

export default component.exports